import * as zod from 'zod';

const FIELD_NAME = 'code';
const CODE_DIGITS = 4;

const SMS_CODE_ERRORS = {
  OTP_CODE_INVALID: 'OTP_CODE_INVALID',
  OTP_CODE_TOO_SHORT: 'OTP_CODE_TOO_SHORT',
  OTP_CODE_TOO_LONG: 'OTP_CODE_TOO_LONG',
  OTP_CODE_NOT_FOUND: 'OTP_CODE_NOT_FOUND'
};

const SMSCodeSchema = zod.object({
  [FIELD_NAME]: zod
    .string()
    .regex(/^[0-9]*$/, SMS_CODE_ERRORS.OTP_CODE_INVALID)
    .min(CODE_DIGITS, SMS_CODE_ERRORS.OTP_CODE_TOO_SHORT)
}).required();

export {
  FIELD_NAME,
  CODE_DIGITS,
  SMS_CODE_ERRORS,
  SMSCodeSchema
};
